import { render } from "./ForgotConfirmationForm.vue?vue&type=template&id=16e70dd9"
import script from "./ForgotConfirmationForm.vue?vue&type=script&lang=js"
export * from "./ForgotConfirmationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__